// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2bzy8","title":"ClientCherryInfo_title__3UplY","itemText":"ClientCherryInfo_itemText__1SbLh"};